export const DATE_FORMAT = "dd-MM-yyyy";
export const DATETIME_FORMAT = "dd-MM-yyyy hh:mm a";